var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_7915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9998C15.346 16.9998 14 15.6538 14 13.9998C14 12.3458 15.346 10.9998 17 10.9998H18.6667V9.6665C18.6667 8.93117 18.0687 8.33317 17.3333 8.33317H16.6667V6.99984C16.6667 6.2645 16.0687 5.6665 15.3333 5.6665H6C5.01133 5.6665 4.194 6.38917 4.034 7.3325C4.01933 7.38717 4 7.4405 4 7.49984V17.6665C4 18.7692 4.89733 19.6665 6 19.6665H17.3333C18.0687 19.6665 18.6667 19.0685 18.6667 18.3332V16.9998H17ZM5.33333 7.6665C5.33333 7.29917 5.632 6.99984 6 6.99984H15.3333V8.33317H6C5.632 8.33317 5.33333 8.03384 5.33333 7.6665Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12H17C15.8973 12 15 12.8973 15 14C15 15.1027 15.8973 16 17 16H19.5C19.776 16 20 15.776 20 15.5V12.5C20 12.224 19.776 12 19.5 12ZM17 14.6667C16.632 14.6667 16.3333 14.368 16.3333 14C16.3333 13.632 16.632 13.3333 17 13.3333C17.368 13.3333 17.6667 13.632 17.6667 14C17.6667 14.368 17.368 14.6667 17 14.6667Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.38ba66547cb7827735b6a1b39a541a76.svg";
export { ForwardRef as ReactComponent };